import types from '../../mutation-types';
import {
  SESSION_STORAGE_KEYS,
  sessionStorage,
} from 'dashboard/helper/sessionStorage';
import PaymentsAPI from '../../../api/payments';

export const actions = {
  async getPaymentsAccount({ commit }, { accountId, isUUID = false }) {
    try {
      commit(types.SET_PAYMENTS_UI_FLAG, { isFetching: true });
      commit(types.CLEAR_PAYMENTS_ACCOUNT);

      const { data } = isUUID
        ? await PaymentsAPI.getPaymentsAccount(accountId)
        : await PaymentsAPI.getPaymentsAccountWithChatlynAccountId(accountId);

      if (!data) {
        throw new Error('No payments account data received');
      }

      commit(types.SET_PAYMENTS_ACCOUNT, data);
    } catch (error) {
      // TODO: Error
    } finally {
      commit(types.SET_PAYMENTS_UI_FLAG, { isFetching: false });
    }
  },

  async getInvoicesByChatlynAccountId({ commit }, { chatlynAccountId, params }) {
    try {
      commit(types.SET_PAYMENTS_UI_FLAG, { isFetching: true, isInvoicesFetchError: false });
      commit(types.CLEAR_PAYMENTS_INVOICES);

      const { data } = await PaymentsAPI.getInvoicesByChatlynAccountId(
        chatlynAccountId,
        params
      );

      if (!data) {
        throw new Error('No invoices data received');
      }

      commit(types.SET_PAYMENTS_INVOICES, data);
    } catch (error) {
      commit(types.SET_PAYMENTS_UI_FLAG, { isInvoicesFetchError: true });
    } finally {
      commit(types.SET_PAYMENTS_UI_FLAG, { isFetching: false });
    }
  },

  async getPaymentStatus({ commit }, accountId) {
    try {
      commit(types.CLEAR_PAYMENT_STATUS);
      commit(types.SET_PAYMENTS_UI_FLAG, { isPaymentStatusFetching: true });

      const { data } = await PaymentsAPI.getPaymentStatus(accountId);

      if (!data) {
        throw new Error('Payment status data is missing from API response');
      }

      commit(types.SET_PAYMENT_STATUS, data);
    } catch (error) {
      // TODO: Handle error
    } finally {
      commit(types.SET_PAYMENTS_UI_FLAG, { isPaymentStatusFetching: false });
    }
  },

  setIsUnpaidInvoiceBannerDismissed({ commit }, newValue) {
    sessionStorage.set(
      SESSION_STORAGE_KEYS.IS_UNPAID_INVOICE_BANNER_DISMISSED,
      newValue
    );
    commit(types.SET_PAYMENTS_UI_FLAG, {
      isUnpaidInvoiceBannerDismissed: newValue,
    });
  },
};
